import { Bibliography } from "../types/bibliography";
import BaseEntityService from "./baseEntityService";

const serviceUrlSuffix = "v1/bibliographies";

class BibliographyService extends BaseEntityService<Bibliography> {
  constructor() {
    super(serviceUrlSuffix);
  }
}

export const bibliographyService = new BibliographyService();

